import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileService } from '../auth/profile.service';
import { SESSION_STORAGE_KEY } from 'src/app/const/session-storage-key';


@Component({
    templateUrl: './no-connection.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule]
})
export class NoConnectionComponent implements OnInit {
  private readonly translationIndex = 'noConnection';
  message: any;

  constructor(private readonly pfs: ProfileService) { }

  ngOnInit() {
    sessionStorage.removeItem(SESSION_STORAGE_KEY.adminUIPath);
    this.message = this.pfs.messages[this.translationIndex];
  }

}
